import React from 'react';

import {
    loadingErrorViewError,
    loadingErrorViewErrorSubtitle,
    loadingErrorViewErrorTitle,
} from './loading-error-view.module.styl';

type Props = {title?: string, subtitle?: string};

const SERVER_UNAVAILABLE_TITLE = 'Service is temporarily unavailable';
const PLEASE_RUN_AGAIN = 'Please try again';
export const LoadingErrorView = ({title = SERVER_UNAVAILABLE_TITLE, subtitle = PLEASE_RUN_AGAIN}: Props) => (
    <div className={loadingErrorViewError}>
        <div className={loadingErrorViewErrorTitle}>
            {title}
        </div>
        <div className={loadingErrorViewErrorSubtitle}>
            {subtitle}
        </div>
    </div>
);

export const AccessDeniedErrorView = () => (
    <LoadingErrorView title="Access Denied" subtitle="You have no access to this page"/>
);
